/**
 * SpacedLabel — 固定幅のチップ/ボタンの中で、2文字ラベルを3文字ぶんの幅に見せる（2026-08-25）
 *
 * 以前は全角スペースを挟んで「店　舗」という文字列にしていたが、ブラウザの検索
 * （Cmd+F）で「店舗」が引っかからなくなるため、字間（letter-spacing）で広げる方式に
 * 変えた。テキストノードは「店舗」のまま1つなので検索でヒットする。
 *
 * 打ち消し用の margin-right が要る理由は displayFormat.spacedLabelStyle() のコメント参照。
 */
import React from 'react';
import { spacedLabelStyle } from '../lib/displayFormat';

export default function SpacedLabel({ label }: { label: string }) {
  const style = spacedLabelStyle(label);
  if (!style) return <>{label}</>;
  return <span style={style}>{label}</span>;
}
